export default {
  getExtensionFromURL: function getExtensionFromURL(url) {
    return url.split('?')[0].split('.').pop();
  },
  isImageExtension: function isImageExtension() {
    var extension = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return ['png', 'jpg', 'jpeg', 'gif'].includes(extension.toLowerCase());
  },
  isPDFExtension: function isPDFExtension() {
    var extension = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return ['pdf'].includes(extension.toLowerCase());
  },
  getDownloadUrl: function getDownloadUrl(url, name) {
    return url.includes('attachment') ? url : "".concat(url, "?response-content-disposition=attachment%3B%20filename%3D").concat(name);
  },
  bytesToSize: function bytesToSize(bytes) {
    if (!bytes) return '';
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    if (bytes === 0) {
      return '0 Byte';
    }

    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return Math.round(bytes / Math.pow(1024, i), 2) + sizes[i];
  }
};